import { Phone, MessageCircle, Refrigerator, Tv, Smartphone, CheckCircle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";

const ServicesPage = () => {
  const phoneNumber = "05075537051";
  const whatsappNumber = "905075537051";
  const whatsappMessage = encodeURIComponent("Merhaba, eşya satmak istiyorum. Bilgi alabilir miyim?");
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  const services = [
    {
      id: "beyaz-esya",
      title: "İkinci El Beyaz Eşya Alan Yerler",
      subtitle: "İkinci El Beyaz Eşya Alanlar",
      icon: Refrigerator,
      description: "İstanbul'da ikinci el beyaz eşya alım hizmetimizle kullanmadığınız veya yenilemek istediğiniz tüm beyaz eşyalarınızı değerinde satın alıyoruz. Sıfır, ikinci el veya defolu fark etmeksizin tüm beyaz eşyalarınız için kapınıza kadar geliyor, yerinde ekspertiz yapıyor ve anında nakit ödeme gerçekleştiriyoruz.",
      items: [
        "Buzdolabı (tek kapı, çift kapı, no-frost)",
        "Çamaşır Makinesi (tüm marka ve modeller)",
        "Bulaşık Makinesi",
        "Kurutma Makinesi",
        "Ankastre Set (fırın, ocak, davlumbaz)",
        "Derin Dondurucu",
        "Şofben ve Kombi",
      ],
      features: [
        "Tüm marka ve modeller değerlendirilir",
        "Defolu ve arızalı eşyalar da alınır",
        "Ücretsiz ekspertiz hizmeti",
        "Aynı gün servis imkanı",
        "Nakit ödeme garantisi",
      ],
    },
    {
      id: "televizyon",
      title: "İkinci El Televizyon Alan Yerler",
      subtitle: "İkinci El Televizyon Alanlar",
      icon: Tv,
      description: "İkinci el televizyon alım hizmetimizle eski veya kullanmadığınız televizyonlarınızı en uygun fiyatla satın alıyoruz. Led TV, LCD TV, Smart TV, QLED TV, Android TV ve tüm diğer televizyon türlerinde profesyonel değerlendirme yapıyoruz.",
      items: [
        "LED TV (tüm boyutlar)",
        "LCD TV",
        "Smart TV",
        "QLED TV",
        "Android TV",
        "OLED TV",
        "Curved (Kavisli) TV",
        "Plazma TV",
      ],
      features: [
        "32 inç'ten 85 inç'e tüm boyutlar",
        "Ekran hasarlı TV'ler de değerlendirilir",
        "Uzaktan kumanda eksik olabilir",
        "Yerinde test ve değerlendirme",
        "Anında nakit ödeme",
      ],
    },
    {
      id: "led-tv",
      title: "İkinci El Led TV Alan Yerler",
      subtitle: "İkinci El Led TV Alanlar",
      icon: Tv,
      description: "LED teknolojili televizyonlarınız için özel alım hizmeti sunuyoruz. Samsung, LG, Sony, Philips, Vestel ve diğer tüm markaların LED TV modellerini değerinde satın alıyoruz. Ekran boyutu ve durumu fark etmeksizin tüm LED TV'leriniz için teklif alabilirsiniz.",
      items: [
        "Samsung LED TV",
        "LG LED TV",
        "Sony LED TV",
        "Philips LED TV",
        "Vestel LED TV",
        "TCL LED TV",
        "Arçelik LED TV",
        "Diğer markalar",
      ],
      features: [
        "Full HD ve 4K modeller",
        "Akıllı ve standart LED TV'ler",
        "Duvar askısı dahil alınabilir",
        "Model yılı fark etmez",
        "Hızlı değerlendirme ve ödeme",
      ],
    },
    {
      id: "elektronik",
      title: "İkinci El Elektronik Eşya Alan Yerler",
      subtitle: "İkinci El Elektronik Eşya Alanlar",
      icon: Smartphone,
      description: "Ev elektroniği ve akıllı cihazlarınızı nakit karşılığında satın alıyoruz. Klima, ses sistemleri, oyun konsolları ve diğer elektronik eşyalarınız için profesyonel değerlendirme hizmeti sunuyoruz.",
      items: [
        "Klima (split, salon tipi)",
        "Ses sistemleri ve hoparlörler",
        "Ev sinema sistemleri",
        "Akıllı ev cihazları",
        "Oyun konsolları",
        "Elektrikli süpürge (robot dahil)",
        "Küçük ev aletleri",
      ],
      features: [
        "Tüm elektronik cihazlar değerlendirilir",
        "Aksesuarlar eksik olabilir",
        "Arızalı ürünler de alınır",
        "Toplu alımlarda özel fiyat",
        "7/24 hizmet",
      ],
    },
  ];

  return (
    <div data-testid="services-page">
      {/* Hero Section */}
      <section className="bg-slate-50 py-16 md:py-24" data-testid="services-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <p className="text-[#002FA7] font-semibold text-sm uppercase tracking-widest mb-3">
              HİZMETLERİMİZ
            </p>
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 tracking-tight mb-6">
              İkinci El Eşya Alım Hizmetlerimiz
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              İstanbul genelinde ikinci el beyaz eşya, televizyon ve elektronik eşya alımı yapıyoruz. Sıfır, ikinci el veya defolu tüm eşyalarınız için kapınıza kadar geliyor, yerinde ekspertiz yapıyor ve anında nakit ödeme gerçekleştiriyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Services Detail */}
      <section className="py-16 md:py-24" data-testid="services-detail">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-16">
            {services.map((service, index) => (
              <div
                key={service.id}
                id={service.id}
                className="scroll-mt-24"
                data-testid={`service-section-${service.id}`}
              >
                <Card className="overflow-hidden border border-slate-200">
                  <CardHeader className="bg-slate-50 border-b border-slate-200">
                    <div className="flex items-start gap-4">
                      <div className="service-icon">
                        <service.icon className="w-7 h-7" />
                      </div>
                      <div>
                        <CardTitle className="text-2xl font-bold text-slate-900 mb-1">
                          {service.title}
                        </CardTitle>
                        <p className="text-[#002FA7] font-medium">{service.subtitle}</p>
                      </div>
                    </div>
                  </CardHeader>
                  <CardContent className="p-6 md:p-8">
                    <p className="text-slate-600 leading-relaxed mb-6">
                      {service.description}
                    </p>

                    <div className="grid md:grid-cols-2 gap-8">
                      {/* Items */}
                      <div>
                        <h4 className="font-semibold text-slate-900 mb-4">Satın Aldığımız Ürünler</h4>
                        <ul className="space-y-2">
                          {service.items.map((item, i) => (
                            <li key={i} className="flex items-center gap-2 text-slate-600 text-sm">
                              <CheckCircle className="w-4 h-4 text-[#128C7E] flex-shrink-0" />
                              <span>{item}</span>
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Features */}
                      <div>
                        <h4 className="font-semibold text-slate-900 mb-4">Hizmet Özellikleri</h4>
                        <ul className="space-y-2">
                          {service.features.map((feature, i) => (
                            <li key={i} className="flex items-center gap-2 text-slate-600 text-sm">
                              <CheckCircle className="w-4 h-4 text-[#002FA7] flex-shrink-0" />
                              <span>{feature}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {/* CTA */}
                    <div className="mt-8 pt-6 border-t border-slate-200 flex flex-wrap gap-4">
                      <a
                        href={`tel:${phoneNumber}`}
                        className="cta-primary"
                        data-testid={`service-phone-btn-${service.id}`}
                      >
                        <Phone className="w-5 h-5" />
                        <span>Hemen Ara</span>
                      </a>
                      <a
                        href={whatsappUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cta-whatsapp"
                        data-testid={`service-whatsapp-btn-${service.id}`}
                      >
                        <MessageCircle className="w-5 h-5" />
                        <span>Resim Yolla & Teklif Al</span>
                      </a>
                    </div>
                  </CardContent>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SEO Content Section */}
      <section className="py-16 md:py-24 bg-slate-50" data-testid="services-seo">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-slate-900 tracking-tight mb-6 text-center">
            İstanbul'da İkinci El Eşya Alım Hizmetleri
          </h2>
          <div className="prose prose-slate max-w-none">
            <p className="text-slate-600 leading-relaxed mb-4">
              <strong>İkinci el beyaz eşya alan yerler</strong> arayanlar için İstanbul'un en güvenilir adresi olarak hizmet veriyoruz. Buzdolabı, çamaşır makinesi, bulaşık makinesi ve ankastre set gibi tüm beyaz eşyalarınızı değerinde satın alıyoruz.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4">
              <strong>İkinci el televizyon alan yerler</strong> ve <strong>ikinci el televizyon alanlar</strong> kategorisinde de profesyonel hizmet sunuyoruz. LED TV, LCD TV, Smart TV, QLED TV ve Android TV dahil tüm televizyon türlerini satın alıyoruz.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4">
              <strong>İkinci el led tv alan yerler</strong> olarak Samsung, LG, Sony ve diğer markaların tüm LED TV modellerini değerlendiriyoruz. Ekran boyutu ve durumu ne olursa olsun teklif alabilirsiniz.
            </p>
            <p className="text-slate-600 leading-relaxed">
              <strong>İkinci el elektronik eşya alan yerler</strong> ve <strong>ikinci el elektronik eşya alanlar</strong> olarak klima, ses sistemleri ve tüm ev elektroniği ürünlerini de satın alıyoruz. Sıfır, ikinci el veya defolu fark etmez, tüm eşyalarınız için kapınıza kadar geliyoruz.
            </p>
          </div>

          {/* Keywords */}
          <div className="mt-8 flex flex-wrap justify-center gap-2">
            {[
              "İkinci el beyaz eşya alan yerler",
              "İkinci el beyaz eşya alanlar",
              "İkinci el televizyon alan yerler",
              "İkinci el televizyon alanlar",
              "İkinci el led tv alan yerler",
              "İkinci el led tv alanlar",
              "İkinci el elektronik eşya alan yerler",
              "İkinci el elektronik eşya alanlar",
            ].map((keyword) => (
              <span key={keyword} className="seo-tag">{keyword}</span>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-[#002FA7]" data-testid="services-cta">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight mb-4">
            Eşyanız İçin Teklif Alın
          </h2>
          <p className="text-blue-100 text-lg mb-8">
            WhatsApp üzerinden eşyanızın fotoğraflarını gönderin, dakikalar içinde teklif alın.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={`tel:${phoneNumber}`}
              className="inline-flex items-center justify-center gap-2 bg-white text-[#002FA7] px-6 py-3.5 rounded-lg font-semibold hover:bg-slate-100 transition-colors"
              data-testid="services-cta-phone-btn"
            >
              <Phone className="w-5 h-5" />
              <span>0507 553 70 51</span>
            </a>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white px-6 py-3.5 rounded-lg font-semibold hover:bg-[#128C7E] transition-colors"
              data-testid="services-cta-whatsapp-btn"
            >
              <MessageCircle className="w-5 h-5" />
              <span>WhatsApp'tan Yaz</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
